export default "__VITE_ASSET__7Uoek5ru__"